(() => {
  if (customElements.get('kom-shipping-complements')) return;
  const root = () => window.Shopify?.routes?.root || '/';
  let catalogPromise;
  let catalogTime = 0;
  let adding = false;
  const catalog = (fresh = false) => {
    if (fresh || !catalogPromise || Date.now() - catalogTime > 10000) {
      catalogTime = Date.now();
      catalogPromise = fetch(`${root()}?section_id=kom-complement-data`, {cache: 'no-store'})
        .then(r => { if (!r.ok) throw Error(); return r.text(); })
        .then(html => JSON.parse(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kom-complement-catalog]').textContent).products)
        .catch(e => { catalogPromise = null; throw e; });
    }
    return catalogPromise;
  };
  const money = value => new Intl.NumberFormat('es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0}).format(value / 100);
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  class KomShippingComplements extends HTMLElement {
    static eligible(products, cart, currentProduct, target) {
      const remaining = target - cart.total_price;
      if (cart.currency !== 'COP' || !cart.items?.length || remaining <= 0) return [];
      const relevant = cart.items.some(item => /cicl|running|medias|guant|mangas|cuello|gel|deport|jersey|badana|pantaloneta|licra|termo|caramañola|botil|estuche/i.test(`${item.product_title} ${item.product_type}`));
      if (!relevant) return [];
      const excluded = new Set(cart.items.map(item => String(item.product_id)));
      if (currentProduct) excluded.add(String(currentProduct));
      const candidates = products.filter(p => !excluded.has(String(p.id))).map(p => ({...p, variants:p.variants.filter(v => v.available && v.price >= remaining && v.price > 0).sort((a,b) => a.price-b.price)})).filter(p => p.variants.length);
      const singleGel = 'gel-energetico-kom-23-g-de-carbohidratos';
      const packGel = 'gel-kom-energetico-naranja-jengibre-23-g-de-carbohidratos-x6und';
      const sleeves = 'mangas-deportivas-de-tela-licrada-para-ciclismo-y-running';
      const singleCoversGap = candidates.some(p => p.handle === singleGel);
      const preferred = candidates.filter(p => p.handle !== sleeves && !(p.handle === packGel && singleCoversGap));
      return (preferred.length ? preferred : candidates.filter(p => p.handle === sleeves)).slice(0,3);
    }
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.version = (this.version || 0) + 1;
      document.addEventListener('cart:change', e => this.update(e.detail?.cart), {signal:this.controller.signal});
      document.addEventListener('cart:refresh', () => this.refresh(), {signal:this.controller.signal});
      window.addEventListener('pageshow', () => this.refresh(), {signal:this.controller.signal});
      this.refresh();
    }
    disconnectedCallback() {this.controller?.abort();this.version++;}
    async refresh() {
      const version = ++this.version;
      try {
        const r = await fetch(`${root()}cart.js`, {cache:'no-store'});
        if (!r.ok) return;
        const cart = await r.json();
        if (this.isConnected && version === this.version) this.update(cart);
      } catch (_) {}
    }
    async update(cart) {
      if (!cart || !Number.isFinite(cart.total_price)) return;
      const version = ++this.version;
      this.cart = cart;
      this.hidden = true;
      try {
        if (cart.currency !== 'COP' || cart.total_price >= Number(this.dataset.target) || !cart.items?.length) return;
        const products = await catalog();
        if (!this.isConnected || version !== this.version) return;
        const choices = KomShippingComplements.eligible(products,cart,this.dataset.currentProduct,Number(this.dataset.target));
        const list = this.querySelector('[data-complements-list]');
        list.replaceChildren(...choices.map(p => this.card(p)));
        this.hidden = choices.length === 0;
      } catch (_) {this.hidden = true;}
    }
    card(product) {
      const card = element('div',null,'kom-complement');
      const image = element('img');image.src=product.image;image.alt='';image.loading='lazy';image.width=52;image.height=64;
      const body = element('div');
      const link = element('a',product.title);link.href=product.url;
      const price = element('strong',money(product.variants[0].price));
      const select = element('select');select.setAttribute('aria-label',`${this.dataset.choose}: ${product.title}`);
      const placeholder = element('option',this.dataset.choose);placeholder.value='';placeholder.disabled=true;placeholder.selected=true;
      select.append(placeholder);
      product.variants.forEach(v => {const o=element('option',`${v.title === 'Default Title' ? product.title : v.title} · ${money(v.price)}`);o.value=String(v.id);select.append(o);});
      const button = element('button',this.dataset.add);button.type='button';button.disabled=true;
      if (product.variants.length === 1) {select.value=String(product.variants[0].id);button.disabled=false;}
      select.addEventListener('change',()=>{button.disabled=!select.value;price.textContent=money(product.variants.find(v=>String(v.id)===select.value).price);});
      button.addEventListener('click',()=>this.add(product,select.value,button));
      body.append(link,price,select,button);card.append(image,body);return card;
    }
    async add(product,variantId,button) {
      if (adding || !variantId) return;
      adding=true;button.disabled=true;button.textContent=this.dataset.adding;button.setAttribute('aria-busy','true');
      const status=this.querySelector('[data-complements-status]');status.textContent='';
      let added=false;
      try {
        const [products,r]=await Promise.all([catalog(true),fetch(`${root()}cart.js`,{cache:'no-store'})]);
        if (!r.ok) throw Error(this.dataset.error);
        const cart=await r.json();
        const stillEligible=KomShippingComplements.eligible(products,cart,this.dataset.currentProduct,Number(this.dataset.target)).some(p=>p.id===product.id && p.variants.some(v=>String(v.id)===variantId));
        if(!stillEligible){this.update(cart);throw Error(this.dataset.unavailable);}
        const sections=[];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        const response=await fetch(`${root()}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}],sections:[...new Set(sections)].slice(0,5),sections_url:window.location.pathname})});
        const result=await response.json();
        if(!response.ok)throw Error(result.description || this.dataset.error);
        added=true;
        if(window.themeVariables?.settings?.pageType==='cart'){window.location.assign(`${root()}cart`);return;}
        const updatedResponse=await fetch(`${root()}cart.js`,{cache:'no-store'});
        if(!updatedResponse.ok)throw Error();
        const updated=await updatedResponse.json();updated.sections=result.sections || {};
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart:updated}}));
        status.textContent=this.dataset.added;
      } catch(error) {
        if(added){window.location.assign(`${root()}cart`);return;}
        status.textContent=error.message || this.dataset.error;
      } finally {adding=false;button.disabled=false;button.textContent=this.dataset.add;button.removeAttribute('aria-busy');}
    }
  }
  customElements.define('kom-shipping-complements',KomShippingComplements);
})();
